var map = {
	"./2015.jpg": 150,
	"./2015_conf_A_Product_Manager_Should_Own_a_Job.png": 151,
	"./2015_conf_Anatomy_of_pd_or_How_to_Find_Your_True_North.png": 152,
	"./2015_conf_Creating_Meaning.png": 153,
	"./2015_conf_Creating_a_Hardware_Product_Startup.png": 154,
	"./2015_conf_Design_Story_of_Smart_Food_Nutrition.png": 155,
	"./2015_conf_Design_for_Enterprise_Processes.png": 156,
	"./2015_conf_Designing_for_Tomorrows_Smart_Systems.png": 157,
	"./2015_conf_Digital_Physical_Product_Startups.png": 158,
	"./2015_conf_Five_Lessons_from_the_Battelfield.png": 159,
	"./2015_conf_From_Story_to_Product_in_180_Days.png": 160,
	"./2015_conf_Personal_Design_X.png": 161,
	"./2015_conf_Product_Manager_vs_Product_Owner_Dilemma.png": 162,
	"./2015_conf_Product_Strategy_Product_Success.png": 163,
	"./2016.png": 164,
	"./2016_conf_Building_Insanely_Great_Products.png": 165,
	"./2016_conf_From_Idea_to_Launch.png": 166,
	"./2016_conf_Ideas_Dont_Sell_Themselves.png": 167,
	"./2016_conf_Insigths_25_Years_Productizing.png": 168,
	"./2016_conf_Intro_Andre_Marquet.png": 169,
	"./2016_conf_Introduction_to_Modern_Product_Discovery.png": 170,
	"./2016_conf_Make_it_Clear.png": 171,
	"./2016_conf_Manage_Global_Design_Teams.png": 172,
	"./2016_conf_Power_to_Create_Connect_and_Inspire.png": 173,
	"./2016_conf_Productization_Mindset.png": 174,
	"./2016_conf_So_You_Want_to_be_a_Service_Designer.png": 175,
	"./2016_conf_Tools_for_Better_Products.png": 176,
	"./2017.jpg": 177,
	"./2017_conf_A_Playbook_for_Achieving_Product_Market_Fit.png": 178,
	"./2017_conf_Bringing_Agile_to_your_Extended_Teams.jpg": 179,
	"./2017_conf_Everything_is_a_Product.png": 180,
	"./2017_conf_Implants_and_Body_Hacking.png": 181,
	"./2017_conf_Innovation_Strategies.jpg": 182,
	"./2017_conf_Lean_Product_in_a_Huge_Company.png": 183,
	"./2017_conf_MVPs_are_too_Expensive.png": 184,
	"./2017_conf_Product_Centricity.png": 185,
	"./2017_conf_Product_Culture_in_a_Growing_Organisation.png": 186,
	"./2017_conf_Product_Lifecycle.jpg": 187,
	"./2017_conf_Successful_Products_by_Prioritizing_Team_Happiness.png": 188,
	"./2017_conf_The_5_PM_Personas.png": 189,
	"./2017_conf_The_Product_Formula.png": 190,
	"./2018.jpg": 191,
	"./2018_conf _Escaping_the_Build_Trap.png": 192,
	"./2018_conf _Success_Requires_Making_Tough_Decisions.png": 193,
	"./2018_conf_Extraordinary_Results_with_Ordinary_People.png": 194,
	"./2018_conf_Hacking_your_Tractor_with_Black_Market_Code.png": 195,
	"./2018_conf_Improving_the_Process_of_Product_Decisions_Making.png": 196,
	"./2018_conf_Shipping_Product_at_Scale.png": 197,
	"./2018_conf_Ten_Things_to_Remember_While_AB_Testing.png": 198,
	"./2018_conf_User_Value_Creation.png": 199,
	"./2018_conf_Using_Data_to_Set_Product_Strategy.png": 200,
	"./2019.jpg": 201,
	"./2019_conf _Iterating_Toward_a_Better_Product_Culture.png": 202,
	"./2019_conf_Anticipatory_Design_Future_Experience.png": 203,
	"./2019_conf_Best_Practices_for_Product_Roadmaps.png": 204,
	"./2019_conf_Conflict_Resolution_for_People_Who_Hate_Conflict.png": 205,
	"./2019_conf_Great_User_Research_for_Non-Researchers.png": 206,
	"./2019_conf_How_to_Build_Trust _with_Customers.png": 207,
	"./2019_conf_Moving_into_Management_Leadership.png": 208,
	"./2019_conf_Netflixs_Customer_Obsession.png": 209,
	"./2019_conf_Overcome_your_Innovation_Biases.png": 210,
	"./2019_conf_Product_Culture_Eats_Execution_Culture.png": 211,
	"./2019_conf_The_Engineering_Lead.png": 212,
	"./2019_conf_Winning_Product_Ideas_Strategy_over_Beauty.png": 213
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 57;